import React from "react";

const toggle = (arr, v) => (arr.includes(v) ? arr.filter((x) => x !== v) : [...arr, v]);

export const RowAccessEditor = ({ value, onChange, roles, homes, row, disabled }) => (
  <div className={`flex flex-wrap items-center gap-3 ${disabled ? "opacity-50 pointer-events-none" : ""}`} data-testid={`access-editor-${row}`}>
    <label className="text-xs text-slate-600">Role
      <select value={value.access_role || ""} onChange={(e) => onChange({ access_role: e.target.value })} className="ml-1.5 px-2 py-1 rounded border border-slate-200 text-sm bg-white" data-testid={`access-role-${row}`}>
        <option value="">— choose —</option>
        {roles.map((r) => <option key={r} value={r}>{r}</option>)}
      </select>
    </label>
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="text-xs text-slate-600">Homes</span>
      {homes.map((h) => (
        <label key={h} className={`text-[12.5px] px-2 py-0.5 rounded-full border cursor-pointer ${value.assigned_homes.includes(h) ? "bg-sky-700 text-white border-sky-700" : "bg-white border-slate-200 text-slate-700"}`}>
          <input type="checkbox" className="sr-only" checked={value.assigned_homes.includes(h)} onChange={() => onChange({ assigned_homes: toggle(value.assigned_homes, h) })} data-testid={`access-home-${row}-${h}`} />{h}
        </label>
      ))}
      {!value.assigned_homes.length && <span className="text-[12.5px] text-amber-700">no home access</span>}
    </div>
  </div>
);
